import {WicketOttEntitlement} from '@tisa-group/models';

export class FetchEntitlementForResource {
  constructor(readonly resources: string[]) {}

  static readonly type = '[Entitlements] Load Entitlement for Resource';
}

export class ClearEntitlements {
  static readonly type = '[Entitlements] Clear Entitlements';
}
